import React from 'react';
import isEmpty from 'lodash/isEmpty';

import { FormFieldContext, FormCheckbox } from '@metarouter-private/mr-mui';

import { useUserModalContext } from 'app/settings/user-management-page/context/UserModalContextProvider';

const DEBUGGER_ACCESS_FIELD_NAME = 'debuggerAccess';
const DEBUGGER_ACCESS_FIELD_LABEL = 'User has access to debug data.';

export default function DebuggerAccessField() {
  const { selectedUser } = useUserModalContext();

  const fieldProps = {
    name: DEBUGGER_ACCESS_FIELD_NAME,
    ...(!isEmpty(selectedUser) && {
      defaultValue: selectedUser.metadata.readEvents ?? false,
    }),
  };

  return (
    <FormFieldContext {...fieldProps}>
      <FormCheckbox label={DEBUGGER_ACCESS_FIELD_LABEL} />
    </FormFieldContext>
  );
}
